module.exports = __webpack_public_path__ + "assets/pictograms/email-confirmation-reminder.e5e1b28ef4dbc9119e540f03f4445b27.svg";